<div class="w-full text-left p-1 ">
  <div *ngIf="edizione" class="p-12 rounded-xl shadow-lg w-full inline-grid grid-cols-1 gap-1 w-full"
    style="background-color: {{_bgColor}}">
    <div class="ml-4 block">
      <h1>{{edizione.nome}}</h1>&nbsp;
      <h2>registrazione elenchi presenze:</h2>
    </div>
    <div class="block mx-4 mt-8">
      <p><label class="mr-2">Incolla i codici nell'area di testo</label></p>
      <p>
        <textarea autofocus #input size="40" cols="80" rows="5" id="_insertId" name="_insertId" [(ngModel)]="_insertId" type="text" (keyup.enter)="registra($event)"></textarea>
      </p>
    </div>
    <div #divRegistrati class="w-full" >
    </div>
  </div>
</div>
<script type="text/javascript" language="JavaScript">
  document._insertId.listacode.focus();
</script>
